import React from "react";
// import ReactDOM from "react-dom"; //react-dom 17-
import ReactDOM from 'react-dom/client'; //react-dom 18+
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

// //react-dom 17- must uses this code
// ReactDOM.render(
//   // <React.StrictMode>
//   <BrowserRouter>
//     <App />
//   </BrowserRouter>,
//   // </React.StrictMode>,

//   document.getElementById("root")
// );

// react-dom 18+ must uses this code
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

serviceWorkerRegistration.register();
